// Read More — Horizon v2.1.6 (vanilla JS)
(function(){
  function init(node){
    if (!node) return;
    var content = node.querySelector('.rm__content');
    var btn = node.querySelector('.rm__toggle');
    if (!content || !btn) return;

    // Applique le nombre de lignes configuré via data-lines
    var lines = parseInt(node.getAttribute('data-lines') || '3', 10);
    content.style.setProperty('--rm-lines', lines);

    // Si le contenu ne déborde pas, on peut cacher le bouton
    // (optionnel, décommenter si souhaité)
    // if (content.scrollHeight <= content.clientHeight + 4) {
    //   btn.style.display = 'none';
    //   return;
    // }

    btn.addEventListener('click', function(){
      var open = node.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? (btn.dataset.less || 'Réduire')
                             : (btn.dataset.more || 'Lire la suite');
    }, {passive:true});
  }

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function(){
    document.querySelectorAll('.rm').forEach(init);

    // Si du contenu est chargé dynamiquement (apps/sections AJAX),
    // expose une méthode globale simple :
    window.__initReadMore = function(scope){
      (scope || document).querySelectorAll('.rm').forEach(init);
    };
  });
})();
